import { render, staticRenderFns } from "./CalendarDay.vue?vue&type=template&id=6520acfb&scoped=true&"
import script from "./CalendarDay.vue?vue&type=script&lang=js&"
export * from "./CalendarDay.vue?vue&type=script&lang=js&"
import style0 from "./CalendarDay.vue?vue&type=style&index=0&id=6520acfb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6520acfb",
  null
  
)

export default component.exports